import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { PremissasService } from "../../../services/premissas.service";
import { CarregandoService } from "../../../services/carregando.service";
import { NotificacaoService } from "../../../services/notificacao.service";
import { PremissasSistema } from "../../../models/premissas-sistema";

@Component({
  selector: 'app-estatisticas-modal',
  templateUrl: './estatisticas-modal.component.html',
  styleUrls: ['./estatisticas-modal.component.scss']
})
export class EstatisticasModalComponent implements OnInit {

  idCliente: number;
  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    public dialogRef: MatDialogRef<EstatisticasModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {
    this.idCliente = data.idCliente;
  }

  ngOnInit() {
    this.buscarPremissasSistema();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
